export const storeKey = "dashboard"
